module.exports = __webpack_public_path__ + "img/star-map-step_1.fc6902c.webp";